export default "/images/71bbff3e2f037d0836a96e354d91b2c0.avif";